<template>
  <div>
    <slot name="header" />
    <div v-if="isFetchingUserQualifications">
      <v-skeleton-loader v-for="i in 3" :key="i" type="list-item-avatar" />
    </div>
    <div v-else>
      <QualificationListItem
        v-for="qualification in sortedUserQualifications"
        :qualification="qualification"
        :key="qualification.id"
      />
      <span v-if="isListEmpty">
        <QualificationListItem :qualification="{}" isPlaceholder />
      </span>
    </div>
    <v-divider v-if="showDivider" />
  </div>
</template>

<script>
import QualificationListItem from "@/components/workers/qualifications/QualificationListItem";
import { QUALIFICATIONS_NAMESPACE } from "@/store/modules/users/qualifications";
import { createNamespacedHelpers } from "vuex";
import { copyState } from "@/utils/helpers";
import {
  FETCH_USER_QUALIFICATIONS,
  FETCH_USER_BOOKING_QUALIFICATIONS
} from "@/store/modules/users/qualifications/actions";
import { orderBy, isEmpty } from "lodash";

const { mapActions, mapState } = createNamespacedHelpers(
  QUALIFICATIONS_NAMESPACE
);

export default {
  name: "QualificationList",
  components: { QualificationListItem },
  created() {
    this.bookingId
      ? this.fetchBookingQualifications({
          userId: this.userId,
          bookingId: this.bookingId
        })
      : this.fetchQualifications(this.userId);
  },
  props: {
    userId: {
      type: String,
      required: true
    },
    showDivider: Boolean,
    bookingId: String
  },
  computed: {
    ...mapState(
      copyState(["isFetchingUserQualifications", "currentUserQualifications"])
    ),
    sortedUserQualifications() {
      return orderBy(this.currentUserQualifications, "dateCompleted", "desc");
    },
    isListEmpty() {
      return isEmpty(this.currentUserQualifications);
    }
  },
  methods: {
    ...mapActions({
      fetchQualifications: FETCH_USER_QUALIFICATIONS,
      fetchBookingQualifications: FETCH_USER_BOOKING_QUALIFICATIONS
    })
  }
};
</script>
